import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  BreadcrumbsComponent,
  NgCommonModule,
  type IBreadcrumb,
} from '@principle-theorem/ng-shared';
import { ReportingPermissions } from '@principle-theorem/principle-core/features';
import { ReportBuilderStore } from './report-builder.store';
import { FeatureInfoComponent } from '@principle-theorem/ng-feature-flags';
import { ReportBuilderQueryFormComponent } from './report-builder-query-form/report-builder-query-form.component';
import { ReportBuilderLoaderComponent } from './report-builder-loader/report-builder-loader.component';
import { ReportBuilderChartFiltersComponent } from './report-builder-chart-filters/report-builder-chart-filters.component';
import { ReportBuilderResultsTableComponent } from './report-builder-results-table/report-builder-results-table.component';

@Component({
  selector: 'pr-report-builder',
  templateUrl: './report-builder.component.html',
  styleUrls: ['./report-builder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgCommonModule,
    FeatureInfoComponent,
    BreadcrumbsComponent,
    ReportBuilderQueryFormComponent,
    ReportBuilderLoaderComponent,
    ReportBuilderChartFiltersComponent,
    ReportBuilderResultsTableComponent,
  ],
})
export class ReportBuilderComponent {
  createCustomReportsPermission =
    ReportingPermissions.ReportingCustomReportEdit;
  breadcrumbs: IBreadcrumb[] = [
    { label: 'Reporting' },
    { label: 'Report Builder' },
  ];

  constructor(public store: ReportBuilderStore) {
    this.store.reset();
  }
}
